import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import DataTable from "../../Table/DataTable";
import { getDeliveries } from "../../../REDUX/actions/delivery";
import { useDeliveryTable } from "./useDeliveryTable";
import { openRightModal } from "../../../REDUX/actions/rightModal";
import UpdateDeparture from "../../Departure/UpdateDeparture";

const DeliveryTable = () => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const { headers, columns } = useDeliveryTable();
  const { deliveries, loading, pageCount, total } = useSelector(
    (state) => state.deliveryReducer,
  );

  const fetchData = (page, search) => {
    dispatch(getDeliveries(page, search));
  };

  return (
    <DataTable
      containerClassName="h-100"
      showRowDetails={false}
      newItemTitle={""}
      title={t("Logistics")}
      headers={headers}
      columns={columns}
      fetchData={fetchData}
      totalPages={pageCount}
      data={deliveries}
      loading={loading}
      total={total}
      noResultsMessage="No results found"
      onRowClick={(id) => dispatch(openRightModal(<UpdateDeparture id={id} />))}
      // addNewItem={() => dispatch(openRightModal(<DepotModal />))}
    />
  );
};

export default DeliveryTable;
